module.exports = __webpack_public_path__ + "img/dgm.872fcc9a.png";